/*
 * @Author: chengjia 645680217@qq.com
 * @Date: 2022-10-31 10:30:10
 * @LastEditors: chengjia 645680217@qq.com
 * @LastEditTime: 2022-12-05 17:53:17
 * @FilePath: \xm-runing-main\src\store\modules\msgStore.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {QueryCommand} from "xmgoing-server"
import {getReadMsg} from '@/api/index'

interface msgAppState {
  msgData: any[],
  msgDataSocket: any[],
  msgDetail: object
}

export const msgStore = defineStore('msgStore', {
  state: (): msgAppState => ({
    msgData:[],
    msgDataSocket: [],
    noticeFlag:true,
    msgDetail: {}
  }),
  getters: {
    // 消息总数
    msgTotal(state) {
      let total = 0
      if (Array.isArray(state.msgData)) {
        state.msgData.forEach(item => {
          total += item.list.length
        })
      }
      //测试数量
      //total = 100
      return total
    }
  },
  actions: {
    setNoticeFlag(noticeFlag){
      this.noticeFlag=noticeFlag;
    },
    // 存储发送的消息
    saveMsg(val) {
      // 判断消息类型
      if (val.type === 'flow') {
        this.msgData.forEach(item => {
          if (item.key === '3') {
            item.list.unshift(val)
          }
        })

      }
    },
    // 已读消息
    removeMsg(val) {
      let queryCommand = new QueryCommand({
        url: '/api/pe-message/inBoxMessage/reads',
        method: 'POST'
      })
      let params = {
        ids: val.id
      }
      queryCommand.executeQuery({
        params,
        successFun: (res) => {
          this.getReadMsg()
        }
      })
    },
    // 存储消息详情
    saveMsgDetail(val) {
      this.msgDetail = {...val}
    },
    // 查询未读消息
    getReadMsg() {
      getReadMsg().then(res => {
        if(res&&Array.isArray(res)){
          this.msgData = res;
          this.msgDataSocket = res;
          //console.log(JSON.stringify(res),"msgDatamsgDatamsgDatamsgDatamsgDatamsgData")
        }
      })
    },
    msgDataSocketfunc(obj){
      this.msgData = obj;
      this.msgDataSocket = obj;
    }
  },

})
